import {
  CircularProgress,
  ButtonProps as MuiButtonProps,
  SxProps,
} from '@mui/material';
import React from 'react';
import { StyledButton } from './button.style';

export interface ButtonProps extends MuiButtonProps {
  loadingStart?: boolean;
  loadingEnd?: boolean;
  id?: string;
}

const Button = (props: ButtonProps) => {
  const {
    loadingStart,
    loadingEnd,
    color = 'primary',
    startIcon,
    endIcon,
    disabled,
    sx,
    id,
    ...restProps
  } = props;

  const loading = loadingStart || loadingEnd;
  const isWhiteColor = color === 'white';
  const whiteColorSx: SxProps = {
    color: 'common.white',
    '&.MuiButton-outlined': {
      border: 'common.white',
    },
  };

  return (
    <StyledButton
      id={id}
      variant="contained"
      size="medium"
      color={isWhiteColor ? 'inherit' : color}
      startIcon={loadingStart ? <Loading /> : startIcon}
      endIcon={loadingEnd ? <Loading /> : endIcon}
      disabled={disabled || loading}
      sx={isWhiteColor ? { ...whiteColorSx, ...sx } : sx}
      {...restProps}
    />
  );
};

export default Button;

const Loading = () => {
  return <CircularProgress size={16} color="inherit" aria-label="loading" />;
};
